import React from 'react'
import Svg from './Svg'
export const SvgWrench = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M23.7 4.2c-.1 0-.4.2-.6.4L20.7 7c-.2.2-.6.2-.8 0L17 4c-.2-.2-.2-.6 0-.8L19.4.8c.2-.2.4-.5.4-.6 0-.1-.2-.3-.5-.3H16c-.3 0-.7.2-.9.4l-2.4 2.4c-.2.2-.4.6-.4.9V7L1 18.4C-.3 19.7-.3 21.7 1 23c1.3 1.3 3.3 1.3 4.6 0l11.3-11.3h3.4c.3 0 .7-.2.9-.4l2.4-2.4c.2-.2.4-.6.4-.9V4.8c0-.3-.1-.6-.3-.6zM3.2 22.9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
  </Svg>
))
SvgWrench.isIcon = true
export default SvgWrench
